var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', {
    attrs: {
      "items": _vm.educationLevels,
      "disabled": _vm.form.educationLevel.isIrrelevant,
      "multiple": "",
      "outlined": "",
      "attach": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.educationLevel.items,
      callback: function ($$v) {
        _vm.$set(_vm.form.educationLevel, "items", $$v);
      },
      expression: "form.educationLevel.items"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "학력무관",
      "dense": "",
      "inset": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.onChangeIsIrrelevant
    },
    model: {
      value: _vm.form.educationLevel.isIrrelevant,
      callback: function ($$v) {
        _vm.$set(_vm.form.educationLevel, "isIrrelevant", $$v);
      },
      expression: "form.educationLevel.isIrrelevant"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "졸업예정자 가능",
      "disabled": _vm.form.educationLevel.isIrrelevant,
      "hide-details": ""
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.form.educationLevel.includesToBe,
      callback: function ($$v) {
        _vm.$set(_vm.form.educationLevel, "includesToBe", $$v);
      },
      expression: "form.educationLevel.includesToBe"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }